module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Kipinto","tos":"TOS","privacy":"Privacy","legals":"Legals"},"fr":{"title":"Kipinto","tos":"CGU","privacy":"Confidentialité","legals":"Mentions Légales"}}')
  delete Component.options._Ctor
}
